// src/components/MissionVision.js

import React from 'react';
import { FaBullseye, FaLightbulb, FaAngleRight } from 'react-icons/fa6';
import './mission-vision.css'; 

const MissionVision = () => {
    return (
        <section className="mission-vision-matrix-flow">
            <div className="container mv-matrix-container">
                
                <h2 className="mv-section-heading">
                    Our Guiding <span className="accent-green-mv">Mission</span> & <span className="accent-magenta-mv">Vision</span>
                </h2>
                
                <div className="mv-grid-matrix">
                    
                    {/* Mission Card: Focus on Precision and Trust */}
                    <div className="mv-card-matrix mission-card">
                        
                        <div className="mv-icon-wrapper mission-icon-bg">
                            <FaBullseye className="mv-icon icon-green-mv" />
                        </div>
                        
                        <h3 className="mv-title">The Mission: Digital Inclusion & Trust</h3>
                        
                        <p className="mv-description">
                            To deliver **timely, transparent, and technology-driven lending solutions** that simplify access to credit for every salaried individual, upholding the highest standards of financial integrity.
                        </p>
                        
                        <a href="#mission-details" className="mv-link icon-green-mv">
                            Learn More About Our Focus <FaAngleRight />
                        </a>
                        
                        {/* Abstract Corner Accent */}
                        <div className="corner-accent accent-green-mv-border"></div>
                    </div>
                    
                    {/* Vertical Divider (The Matrix Flow Separator) */}
                    <div className="mv-separator">
                        <div className="separator-dot dot-top"></div>
                        <div className="separator-line"></div>
                        <div className="separator-dot dot-bottom"></div>
                    </div>

                    {/* Vision Card: Focus on Innovation and Future */}
                    <div className="mv-card-matrix vision-card">
                        
                        <div className="mv-icon-wrapper vision-icon-bg">
                            <FaLightbulb className="mv-icon icon-magenta-mv" />
                        </div>
                        
                        <h3 className="mv-title">The Vision: Gold Standard in Fintech</h3>
                        
                        <p className="mv-description">
                            To be the **most trusted and advanced digital lending platform** in India, setting the global benchmark for ethical, responsible, and data-secure financial services by constant innovation.
                        </p>
                        
                        <a href="#vision-details" className="mv-link icon-magenta-mv">
                            Our Innovation Roadmap <FaAngleRight />
                        </a>
                        
                        {/* Abstract Corner Accent */}
                        <div className="corner-accent accent-magenta-mv-border"></div>
                    </div>
                </div>
            </div>
            
            <div className="section-divider-mv"></div>
        </section>
    );
};

export default MissionVision;